import { render, staticRenderFns } from "./CardAuthorTable.vue?vue&type=template&id=2ac65599&scoped=true"
import script from "./CardAuthorTable.vue?vue&type=script&lang=js"
export * from "./CardAuthorTable.vue?vue&type=script&lang=js"
import style0 from "./CardAuthorTable.vue?vue&type=style&index=0&id=2ac65599&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac65599",
  null
  
)

export default component.exports